function cwToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(window.__cwToastTimer);
  window.__cwToastTimer = setTimeout(() => t.classList.remove('show'), 2200);
}

async function cwRefreshCartCount() {
  try {
    const r = await fetch('/cart.js');
    const cart = await r.json();
    const el = document.getElementById('cart-count');
    if (el) el.textContent = cart.item_count;
  } catch (e) { /* leave old count */ }
}

/* Quick-add: any form with data-quick-add posts to the cart without leaving the page */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[data-quick-add]');
  if (!form) return;
  e.preventDefault();
  const btn = form.querySelector('button[type="submit"]');
  const original = btn.textContent;
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    if (!r.ok) throw new Error('add failed');
    btn.textContent = 'Added ✓';
    btn.classList.add('added');
    cwToast((form.dataset.title || 'Item') + ' added to cart');
    cwRefreshCartCount();
  } catch (err) {
    cwToast('Could not add to cart');
  }
  setTimeout(() => { btn.textContent = original; btn.classList.remove('added'); }, 1400);
});
